import { gsap } from "gsap";
import { Power4 } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useLayoutEffect, useState } from "react";
import img from "../../../../Assets/Images/img-main-partner@3x.png";
import Title from "../../../Common/Title";
import "./styles.scss";

gsap.registerPlugin(ScrollTrigger);

function Partner() {
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useLayoutEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  //animation
  useEffect(() => {
    if (isMobile) return;
    let ctx = gsap.context(() => {
      let timeline = gsap.timeline({
        scrollTrigger: {
          trigger: `.partner-container`,
          start: "top center",
        },
      });

      timeline.from(`.partner-list`, {
        y: 1030,
        duration: 2,
        autoAlpha: 0,
        ease: Power4.easeOut,
        // delay: 1
      });
    });

    return () => ctx.revert();
  }, [isMobile]);

  return (
    <div className="partner">
      <div className="partner-container">
        <Title
          title={
            <>
              고객 관리 운영이 필요한 곳이라면? <br />
              맞춤형 솔루션 제공
            </>
          }
          detail="게임, 건강 분야, 쇼핑몰, 가상화폐 거래소, 블록 체인 등"
        />

        <div className="partner-list">
          <img src={img} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Partner;
